module.exports = function getLanguageFromLocale(locale) {
    return locale.slice(0, 2)
}
